<template>
  <div>
    <back-btn />
    <v-row justify="center">
      <v-col cols="12" md="6">
        <Form @emitDaData="create" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Form from "@/components/clinic/Form";
import BackBtn from "@/components/navigation/BackBtn.vue";

export default {
  components: {
    Form,
    BackBtn,
  },
  data: () => ({}),
  methods: {
    create(payload) {
      console.log(payload);
      this.$store.dispatch("Clinic/create", payload).then(() => {
        this.$router.push("/clinic");
      });
    },
  },
};
</script>
